import React from 'react';

type Props = {
};

function SelectedContentVideo({ }: Props) {
	return (
		<></>
	);
}

export default SelectedContentVideo;